import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const MySwal = withReactContent(Swal);

export const warningSWAL = (options = {}) => {
  return MySwal.fire({
    title: "Əminsinizmi?",
    icon: "warning",
    showCancelButton: true,
    cancelButtonText: "Xeyr",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Bəli",
    ...options,
  });
};

export const successSWAL = (options = {}) => {
  return MySwal.fire({
    icon: "success",
    title: "Əməliyyat uğurla bitdi",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Tamam",
    timer: false,
    ...options,
  });
};

export const errorSWAL = (options = {}) => {
  return MySwal.fire({
    icon: "error",
    text: "Xəta baş verdi",
    confirmButtonText: "Tamam",
    timer: false,
    ...options,
  });
};

export const imageSWAL = (options = {}) => {
  return MySwal.fire({
    title: "Sweet!",
    text: "Modal with a custom image.",
    imageUrl: "https://unsplash.it/400/200",
    imageWidth: 400,
    imageHeight: 200,
    imageAlt: "Custom image",
  });
};

export const confirmPassSWAL = (options = {}) => {
  return MySwal.fire({
    title: "Əməliyyatı təsdiqləmək üçün şifrənizi daxil edin",
    icon: "info",
    input: "password",
    inputPlaceholder: "şifrə",
    inputAttributes: {
      autocapitalize: "off",
    },
    showCancelButton: true,
    cancelButtonText: "İmtina",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Təsdiqlə",
    ...options,
  });
};

export const requestAlertSWAL = (options = {}) => {
  return MySwal.fire({
    title: "Are you sure?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Qəbul et",
    cancelButtonText: "Qəbul etmə",
    reverseButtons: true,
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger mr-2",
    },
    buttonsStyling: false,
    ...options,
  });
};
